import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'
import {mapValues, pick} from 'lodash'

const CustomersTabs = () => import(/* webpackChunkName: "customers" */'@/views/customer/CustomersTabs')
const Customers = () => import(/* webpackChunkName: "customers" */'@/views/customer/Customers')
const CustomersCharts = () => import(/* webpackChunkName: "customers" */'@/views/customer/charts/Charts')
const CustomersOverview = () => import(/* webpackChunkName: "customers" */'@/views/customer/overview/Overview')
// const CreateContract = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/CreateContract')
const RecalculateMetrics = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/RecalculateMetrics')
const ReallocateCustomer = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/ReallocateCustomer')

const CustomerTabs = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/CustomerTabs')
// const Cancellations = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/Cancellations')
const Contacts = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/Contacts')
// const Contracts = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/Contracts')
// const Invoices = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/Invoices')
const Metrics = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/metrics/Metrics')
const Overview = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/Overview')
const PropertyHistory = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/property-history/PropertyHistory')
const PropertyHistoryTimeline = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/property-history/PropertyHistoryTimeline')
const UpdateProperty = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/property-history/UpdateProperty')
const UserLogs = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/user-log/UserLogs')
const UserLog = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/user-log/UserLog')
const Products = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/Products')
const Services = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/Services')
const EnableService = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/service/EnableService')
const DisableService = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/service/DisableService')

// Numbers
const Numbers = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/Numbers')
const Technologies = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/technologies/Technologies')
const Billing = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/billing/Billing')
const ManageBilling = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/billing/ManageBilling')
const RemoveBilling = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/billing/RemoveBilling')
const ToolboxProductsModal = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/ToolboxProductsModal')
const NumberTabs = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/NumberTabs')
const ChangeOwnership = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/ChangeOwnership')
const NumberOverview = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/Overview')
const NumberService = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/Service')
const ToolboxProducts = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/ToolboxProducts')
const Revisions = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/revisions/Revisions')
const Revision = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/revisions/Revision')
const BarredNumbers = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/barring/BarredNumbers')
const BarNumber = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/barring/BarNumber')
const UnbarNumber = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/barring/UnbarNumber')

// Subaccounts
const Subaccounts = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/subaccount/Subaccounts')
const SubaccountTabs = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/subaccount/SubaccountTabs')
const SubaccountOverview = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/subaccount/Overview')

const SendInvite = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/SendInvite')
const InviteUser = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/InviteUser')
const InviteLegacy = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/InviteLegacy')
const RevokeInvite = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/RevokeInvite')
const DeactivateUser = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/DeactivateUser')
const DeleteUser = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/DeleteUser')
const ForcePasswordChange = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/ForcePasswordChange')
const SendPasswordReset = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/SendPasswordReset')
const Remove2Fa = () => import(/* webpackChunkName: "customers" */'@/views/sso/actions/Remove2Fa')

const SubaccountLogs = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/subaccount/SubaccountLogs')

// Activities
const Activities = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/activities/Activities')
const Activity = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/activities/Activity')

// Bundles
const Bundles = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/bundle/Bundles')
const BundleNumbers = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/bundle/BundleNumbers')
const ManageBundle = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/bundle/ManageBundle')
const UpdateBundle = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/bundle/UpdateBundle')

// Tariffs
const Tariffs = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/tariff/Tariffs')
const TariffLegs = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/tariff/TariffLegs')
const TariffNumbers = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/tariff/TariffNumbers')

// MFA
// const MfaList = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/mfa/MfaList')
// const ManageMfa = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/mfa/ManageMfa')
// const RemoveMfa = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/mfa/RemoveMfa')

function props ({params}) {
    const props = pick(params, [
        'authId',
        'activityId',
        'customerId',
        'bundleId',
        'tariffId',
        'cancellationId',
        'contractId',
        'contactId',
        'subaccountId',
        'metricId',
        'revisionId',
        'logId',
        'billingId',
        'productId',
    ])

    return {
        ...params,
        ...mapValues(props, (prop) => !isNaN(prop) ? Number(prop) : prop)
    }
}

export default {
    path: '/customers/customers',
    alias: '/customers',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            component: CustomersTabs,
            children: [
                {
                    path: 'metrics',
                    name: routeNames.METRICS,
                    meta: {title: 'Metrics'},
                    component: CustomersOverview
                },
                {
                    path: 'metrics/:metricId',
                    name: routeNames.METRIC_TIMELINE,
                    meta: {title: 'Timeline'},
                    component: CustomersOverview,
                    props
                },
                {
                    path: 'charts',
                    name: routeNames.CUSTOMERS_CHARTS,
                    meta: {title: 'Charts'},
                    component: CustomersCharts,
                    props
                },
                {
                    path: '/',
                    name: routeNames.CUSTOMERS,
                    meta: {title: 'Customers'},
                    component: Customers,
                    children: [
                        // {
                        //     path: 'create-contract/:customerId',
                        //     name: routeNames.CREATE_CONTRACT,
                        //     meta: {title: 'Create Contract'},
                        //     component: CreateContract,
                        //     props
                        // },
                        {
                            path: 'recalculate-metrics/:customerId',
                            name: routeNames.RECALCULATE_METRICS,
                            meta: {title: 'Recalculate Metrics'},
                            component: RecalculateMetrics,
                            props
                        },
                        {
                            path: 'reallocate-customer',
                            name: routeNames.REALLOCATE_CUSTOMER,
                            meta: {title: 'Reallocate Customer'},
                            component: ReallocateCustomer,
                            props: route => ({
                                ...route.params,
                                customerIds: route.query?.customerIds?.map(Number)
                            })
                        }
                    ]
                }
            ]
        },
        {
            path: ':customerId',
            component: CustomerTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.CUSTOMER,
                    meta: {title: 'Overview'},
                    component: Overview,
                    props,
                    children: [
                        {
                            path: 'property/:property',
                            name: routeNames.CUSTOMER_PROPERTY_HISTORY_TIMELINE,
                            meta: {title: 'Property History Timeline'},
                            component: PropertyHistoryTimeline,
                            props
                        },
                        {
                            path: 'property/:property/update',
                            name: routeNames.CUSTOMER_PROPERTY_UPDATE,
                            meta: {title: 'Property Update'},
                            component: UpdateProperty,
                            props
                        }
                    ]
                },
                // {
                //     path: 'authentication',
                //     name: routeNames.CUSTOMER_MFA_LIST,
                //     meta: {title: 'Authentication'},
                //     component: MfaList,
                //     props,
                //     children: [
                //         {
                //             path: 'create',
                //             name: routeNames.CUSTOMER_CREATE_MFA,
                //             meta: {title: 'Add Authentication'},
                //             component: ManageMfa,
                //             props
                //         },
                //         {
                //             path: ':authId/remove',
                //             name: routeNames.CUSTOMER_REMOVE_MFA,
                //             meta: {title: 'Remove Authentication'},
                //             component: RemoveMfa,
                //             props
                //         }
                //     ]
                // },
                {
                    path: 'metrics',
                    name: routeNames.CUSTOMER_METRICS,
                    meta: {title: 'Metrics'},
                    component: Metrics,
                    props
                },
                {
                    path: 'metrics/:metricId',
                    name: routeNames.CUSTOMER_METRIC_TIMELINE,
                    meta: {title: 'Timeline'},
                    component: Metrics,
                    props
                },
                {
                    path: 'activities',
                    name: routeNames.CUSTOMER_ACTIVITIES,
                    meta: {title: 'Activities'},
                    component: Activities,
                    props,
                    children: [
                        {
                            path: ':activityId',
                            name: routeNames.CUSTOMER_ACTIVITY,
                            meta: {title: 'Activity'},
                            component: Activity,
                            props
                        }
                    ]
                },
                {
                    path: 'user-logs',
                    name: routeNames.CUSTOMER_USER_LOGS,
                    meta: {title: 'User Logs'},
                    component: UserLogs,
                    props,
                    children: [
                        {
                            path: ':logId',
                            name: routeNames.CUSTOMER_USER_LOG,
                            meta: {title: 'User Log'},
                            component: UserLog,
                            props
                        }
                    ]
                },
                // {
                //     path: 'cancellations',
                //     name: routeNames.CUSTOMER_CANCELLATIONS,
                //     meta: {title: 'Cancellations'},
                //     component: Cancellations,
                //     props
                // },
                {
                    path: 'contacts',
                    name: routeNames.CUSTOMER_CONTACTS,
                    meta: {title: 'Contacts'},
                    component: Contacts,
                    props,
                    children : [
                        {
                            path: ':contactId/invite-user',
                            name: routeNames.CUSTOMER_CONTACT_INVITE_USER,
                            meta: {title: 'Invite to WIMS'},
                            component: InviteUser,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/invite-legacy',
                            name: routeNames.CUSTOMER_CONTACT_INVITE_LEGACY,
                            meta: {title: 'Grant My Windsor access'},
                            component: InviteLegacy,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/send-invite',
                            name: routeNames.CUSTOMER_CONTACT_SEND_INVITE,
                            meta: {title: 'Resend WIMS activation email'},
                            component: SendInvite,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/revoke-invite',
                            name: routeNames.CUSTOMER_CONTACT_REVOKE_INVITE,
                            meta: {title: 'Revoke SSO Invite'},
                            component: RevokeInvite,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/deactivate-user',
                            name: routeNames.CUSTOMER_CONTACT_DEACTIVATE_USER,
                            meta: {title: 'Deactivate User'},
                            component: DeactivateUser,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/delete-user',
                            name: routeNames.CUSTOMER_CONTACT_DELETE_USER,
                            meta: {title: 'Delete User'},
                            component: DeleteUser,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/force-password',
                            name: routeNames.CUSTOMER_CONTACT_FORCE_PASSWORD,
                            meta: {title: 'Force Password Change'},
                            component: ForcePasswordChange,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/reset-password',
                            name: routeNames.CUSTOMER_CONTACT_RESET_PASSWORD,
                            meta: {title: 'Send Password Reset'},
                            component: SendPasswordReset,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                        {
                            path: ':contactId/remove-2fa',
                            name: routeNames.CUSTOMER_CONTACT_REMOVE_2FA,
                            meta: {title: 'Remove 2 Factor Authentication'},
                            component: Remove2Fa,
                            props: (route) => ({
                                contactId: Number(route.params.contactId),
                                customerId: Number(route.params.customerId),
                                type: "customer contact"
                            }),
                        },
                    ]
                },
                {
                    path: 'subaccounts',
                    name: routeNames.CUSTOMER_SUBACCOUNTS,
                    meta: {title: 'Subaccounts'},
                    component: Subaccounts,
                    props,
                    children: [
                        {
                            path: ':subaccountId/invite-user',
                            name: routeNames.CUSTOMER_SUBACCOUNT_INVITE_USER,
                            meta: {title: 'Invite to WIMS'},
                            component: InviteUser,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/invite-legacy',
                            name: routeNames.CUSTOMER_SUBACCOUNT_INVITE_LEGACY,
                            meta: {title: 'Grant My Windsor access'},
                            component: InviteLegacy,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/send-invite',
                            name: routeNames.CUSTOMER_SUBACCOUNT_SEND_INVITE,
                            meta: {title: 'Resend WIMS activation email'},
                            component: SendInvite,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/revoke-invite',
                            name: routeNames.CUSTOMER_SUBACCOUNT_REVOKE_INVITE,
                            meta: {title: 'Revoke SSO Invite'},
                            component: RevokeInvite,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/deactivate-user',
                            name: routeNames.CUSTOMER_SUBACCOUNT_DEACTIVATE_USER,
                            meta: {title: 'Deactivate User'},
                            component: DeactivateUser,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/delete-user',
                            name: routeNames.CUSTOMER_SUBACCOUNT_DELETE_USER,
                            meta: {title: 'Delete User'},
                            component: DeleteUser,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/force-password',
                            name: routeNames.CUSTOMER_SUBACCOUNT_FORCE_PASSWORD,
                            meta: {title: 'Force Password Change'},
                            component: ForcePasswordChange,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/reset-password',
                            name: routeNames.CUSTOMER_SUBACCOUNT_RESET_PASSWORD,
                            meta: {title: 'Send Password Reset'},
                            component: SendPasswordReset,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        },
                        {
                            path: ':subaccountId/remove-2fa',
                            name: routeNames.CUSTOMER_SUBACCOUNT_REMOVE_2FA,
                            meta: {title: 'Remove 2 Factor Authentication'},
                            component: Remove2Fa,
                            props: (route) => ({
                                subaccountId: Number(route.params.subaccountId),
                                customerId: Number(route.params.customerId),
                                type: "subaccount"
                            }),
                        }
                    ]
                },
                // {
                //     path: 'contracts',
                //     name: routeNames.CUSTOMER_CONTRACTS,
                //     meta: {title: 'Contracts'},
                //     component: Contracts,
                //     props
                // },
                // {
                //     path: 'invoices',
                //     name: routeNames.CUSTOMER_INVOICES,
                //     meta: {title: 'Invoices'},
                //     component: Invoices,
                //     props
                // },
                {
                    path: 'numbers',
                    name: routeNames.CUSTOMER_NUMBERS,
                    meta: {title: 'Numbers'},
                    component: Numbers,
                    props,
                    children: [
                        {
                            path: 'toolbox',
                            name: routeNames.CUSTOMER_TOOLBOX_PRODUCTS,
                            meta: {title: 'Toolbox Products'},
                            component: ToolboxProductsModal,
                            props
                        },
                        {
                            path: 'toolbox/:serviceNumber',
                            name: routeNames.CUSTOMER_NUMBERS_PRODUCTS,
                            meta: {title: 'Toolbox Products'},
                            component: ToolboxProductsModal,
                            props
                        }
                    ]
                },
                {
                    path: 'products',
                    name: routeNames.CUSTOMER_PRODUCTS,
                    meta: {title: 'Products'},
                    component: Products,
                    props
                },
                {
                    path: 'services',
                    name: routeNames.CUSTOMER_SERVICES,
                    meta: {title: 'Services'},
                    component: Services,
                    props,
                    children: [
                        {
                            path: 'enable',
                            name: routeNames.CUSTOMER_ENABLE_SERVICE,
                            meta: {title: 'Enable Service'},
                            component: EnableService,
                            props
                        },
                        {
                            path: ':productId/disable',
                            name: routeNames.CUSTOMER_DISABLE_SERVICE,
                            meta: {title: 'Disable Service'},
                            component: DisableService,
                            props
                        }
                    ]
                },
                {
                    path: 'bundles',
                    name: routeNames.CUSTOMER_BUNDLES,
                    meta: {title: 'Bundles'},
                    component: Bundles,
                    props,
                    children: [
                        {
                            path: ':bundleId/numbers',
                            name: routeNames.CUSTOMER_BUNDLE_NUMBERS,
                            meta: {title: 'Bundle Numbers'},
                            component: BundleNumbers,
                            props
                        },
                        {
                            path: ':bundleId/update',
                            name: routeNames.CUSTOMER_BUNDLE_UPDATE,
                            meta: {title: 'Update Bundle'},
                            component: UpdateBundle,
                            props
                        },
                        {
                            path: 'create',
                            name: routeNames.CUSTOMER_BUNDLES_CREATE,
                            meta: {title: 'Create Bundle'},
                            component: ManageBundle,
                            props
                        },
                    ]
                },
                {
                    path: 'tariffs',
                    name: routeNames.CUSTOMER_TARIFFS,
                    meta: {title: 'Tariffs'},
                    component: Tariffs,
                    props,
                    children: [
                        {
                            path: ':tariffId/legs',
                            name: routeNames.CUSTOMER_TARIFF_LEGS,
                            meta: {title: 'Tariff Legs'},
                            component: TariffLegs,
                            props
                        },
                        {
                            path: ':tariffId/numbers',
                            name: routeNames.CUSTOMER_TARIFF_NUMBERS,
                            meta: {title: 'Tariff Numbers'},
                            component: TariffNumbers,
                            props
                        }
                    ]
                },
                {
                    path: 'staff-log',
                    name: routeNames.CUSTOMER_STAFF_LOG,
                    meta: {title: 'Staff Log'},
                    component: PropertyHistory,
                    props
                }
            ]
        },
        {
            path: ':customerId/numbers/:serviceNumber',
            component: NumberTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.CUSTOMER_NUMBER,
                    meta: {title: 'Overview'},
                    component: NumberOverview,
                    props
                },
                {
                    path: 'change-ownership',
                    name: routeNames.CUSTOMER_NUMBER_CHANGE_OWNERSHIP,
                    meta: {title: 'Change Ownership'},
                    component: ChangeOwnership,
                    props
                },
                {
                    path: 'service',
                    name: routeNames.CUSTOMER_NUMBER_SERVICE,
                    meta: {title: 'Service'},
                    component: NumberService,
                    props
                },
                {
                    path: 'products',
                    name: routeNames.CUSTOMER_NUMBER_PRODUCTS,
                    meta: {title: 'Products'},
                    component: ToolboxProducts,
                    props
                },
                {
                    path: 'revisions',
                    name: routeNames.CUSTOMER_NUMBER_REVISIONS,
                    meta: {title: 'Revisions'},
                    component: Revisions,
                    props,
                    children: [
                        {
                            path: ':revisionId',
                            name: routeNames.CUSTOMER_NUMBER_REVISION,
                            meta: {title: 'Revision'},
                            component: Revision,
                            props
                        }
                    ]
                },
                {
                    path: 'barring',
                    name: routeNames.CUSTOMER_NUMBER_BARRING,
                    meta: {title: 'Barring'},
                    component: BarredNumbers,
                    props,
                    children: [
                        {
                            path: 'create',
                            name: routeNames.CUSTOMER_NUMBER_CREATE_BARRING,
                            meta: {title: 'Add Barred Number'},
                            component: BarNumber,
                            props
                        },
                        {
                            path: 'remove/:cli',
                            name: routeNames.CUSTOMER_NUMBER_REMOVE_BARRING,
                            meta: {title: 'Remove Barred Number'},
                            component: UnbarNumber,
                            props
                        }
                    ]
                },
                {
                    path: 'technologies',
                    name: routeNames.CUSTOMER_NUMBER_TECHNOLOGIES,
                    meta: {title: 'Technologies'},
                    component: Technologies,
                    props,
                },
                {
                    path: 'billing',
                    name: routeNames.CUSTOMER_NUMBER_BILLING,
                    meta: {title: 'Billing'},
                    component: Billing,
                    props,
                    children: [
                        {
                            path: ':billingId/update',
                            name: routeNames.CUSTOMER_NUMBER_BILLING_UPDATE,
                            meta: {title: 'Update Billing'},
                            component: ManageBilling,
                            props
                        },
                        {
                            path: ':billingId/remove',
                            name: routeNames.CUSTOMER_NUMBER_BILLING_REMOVE,
                            meta: {title: 'Remove Billing'},
                            component: RemoveBilling,
                            props
                        }
                    ]
                }
            ]
        },
        {
            path: ':customerId/subaccounts/:subaccountId',
            component: SubaccountTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.CUSTOMER_SUBACCOUNT,
                    props,
                    meta: {title: 'Overview'},
                    component: SubaccountOverview
                },
                {
                    path: 'logs',
                    name: routeNames.CUSTOMER_SUBACCOUNT_LOGS,
                    meta: {title: 'Logs'},
                    props,
                    component: SubaccountLogs
                },
            ]
        },
    ]
}
